'use client'

import React from 'react'
import { cva } from 'class-variance-authority'
import { twMerge } from 'tailwind-merge'

const selectVariants = cva(
  'w-full rounded-md border bg-white text-sm outline-none transition-colors disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        default: 'focus:ring-blue-500',
        error: 'border-red-500 focus:ring-red-500',
        success: 'border-green-500 focus:ring-green-500',
      },
      size: {
        sm: 'px-3 py-2',
        md: 'px-4 py-3',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  }
)

export default function Select({
  options = [],
  value,
  onChange,
  variant,
  size,
  className,
  placeholder = 'Select',
  ...props
}) {
  return (
    <select data-component-id="src\components\ui\Select.jsx:39:4" data-component-path="src\components\ui\Select.jsx" data-component-line="39" data-component-end-line="55" data-component-file="Select.jsx" data-component-name="select" data-component-content="%7B%22elementName%22%3A%22select%22%2C%22value%22%3A%22%5Bvar%3Avalue%5D%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
      value={value}
      onChange={onChange}
      className={twMerge(
        selectVariants({ variant, size }),
        value === '' ? 'text-gray-400' : 'text-gray-900',
        className
      )}
      {...props}
    >
      <option data-component-id="src\components\ui\Select.jsx:49:6" data-component-path="src\components\ui\Select.jsx" data-component-line="49" data-component-end-line="49" data-component-file="Select.jsx" data-component-name="option" data-component-content="%7B%22elementName%22%3A%22option%22%2C%22value%22%3A%22%22%7D" value="">{placeholder}</option>
      {options.map(opt => (
        <option data-component-id="src\components\ui\Select.jsx:51:8" data-component-path="src\components\ui\Select.jsx" data-component-line="51" data-component-end-line="53" data-component-file="Select.jsx" data-component-name="option" data-component-content="%7B%22elementName%22%3A%22option%22%2C%22className%22%3A%22text-gray-900%22%7D" key={opt.value} value={opt.value} className="text-gray-900">
          {opt.label}
        </option>
      ))}
    </select>
  )
}
